import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { IGroupDetailDAO, IGroupUser, IGroupUserDAO } from 'types/domain/group';
import { IEntityReducer } from 'core/reducers/entities';
import { selectGroup } from './group';
import { ISearchReducer } from 'core/slices/search';
import { ISearch, SortBy } from 'types/domain/search';
import { getUserName, searchUserName } from './latestUsersReport';
import { convertDate } from 'utils/convertDate';
import { IOrganisationUserDAO } from 'types/domain/user';
import { EntityTypes } from 'constants/entities';

const entity = (state: RootState) => state.entity.present;
const search = (state: RootState) => state.core.search;
const group = selectGroup;

export const selectGroupUsers = createSelector(
  [entity, group, search],
  (entity: IEntityReducer, group: IGroupDetailDAO, search: ISearchReducer) => {
    if (!group) return null;

    return group.groupUsers.map((groupUser: IGroupUserDAO) => {
      return { ...groupUser.organisationUser, groupUserId: groupUser.id } as unknown as IGroupUserDAO;
    });
  },
);

export function parseGroupUser(entity: IEntityReducer, id) {
  const groupUser: IGroupUser = entity[EntityTypes.GROUP_USER][id];

  if (!groupUser) return null;

  return {
    ...groupUser,
    group: entity[EntityTypes.GROUP][groupUser.groupId],
    organisationUser: entity[EntityTypes.ORG_USER][groupUser.organisationUserId],
  } as IGroupUserDAO;
}

export const selectGroupUsers2 = createSelector(
  [entity, group, search],
  (entity: IEntityReducer, group: IGroupDetailDAO, search: ISearch) => {
    if (!group) return [];

    return (
      group.groupUsers
        .filter(g => g.status > -1)
        //.filter(g => g.user?.signin != null)
        .map((groupUser: IGroupUserDAO) => {
          return {
            ...groupUser.organisationUser,
            groupUserId: groupUser.id,

            //user:groupUser.user
          } as unknown as IOrganisationUserDAO;
        })
        .sort((a, b) => sortByNameModified(a, b, search))
        .filter(g => (search.term && search.term.length ? searchGroupUserName(g, search.term) : true))
      // .filter(g => (search.sort === SortBy.NAME ? getUserName(g.user) != null : true))
    );
  },
);

export function searchGroupUserName(g: IOrganisationUserDAO, term) {
  if (g === null) return null;

  return g && term
    ? g?.firstName?.toLowerCase().includes(term.toLowerCase()) ||
        g?.lastName?.toLowerCase().includes(term.toLowerCase()) ||
        g?.email?.toLowerCase().includes(term.toLowerCase())
    : null;
}

export function sortByNameModified(a: IOrganisationUserDAO, b: IOrganisationUserDAO, search: ISearch) {
  if (a === null) return -1;
  if (b === null) return 1;
  //if (a === b) return 0;

  switch (search.sort) {
    case SortBy.NAME:
      if (getUserName(a) == null) return -1;
      if (getUserName(a) == null) return 1;

      return getUserName(a).localeCompare(getUserName(b));
    default:
      if (convertDate(a.created?.date) == null) return 1;
      if (convertDate(b.created?.date) == null) return -1;

      return convertDate(a.created?.date) > convertDate(b.created?.date) ? 1 : -1;
  }
}
